import React from "react";
import { Dialog, DialogContent } from "@mui/material";
import "../css/BecomeMemberDialog.css";

interface ConnectDialogProps {
  open: boolean;
  onClose: () => void;
}

const JoinCircleDialog: React.FC<ConnectDialogProps> = ({ open, onClose }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        className: "become-member-dialog-container",
      }}
      BackdropProps={{
        className: "become-member-dialog-backdrop",
      }}
    >
      <DialogContent sx={{ padding: 0, margin: 0 }}>
        <div className="become-member-dialog-header">
          Step Into the SABE Ecosystem ✨
        </div>
        <div className="become-member-dialog-divider"></div>
        <div className="become-member-dialog-containt-container">
          <p>
            Join a curated community designed for Focused Work, Balanced Energy,
            and Sustainable Growth.
          </p>
        </div>
        <div className="become-member-dialog-button" onClick={onClose}>
          <div>See you on 6th May</div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default JoinCircleDialog;
